import { graphql } from '../__generated__/gql';

export const GET_ALL_SYSTEMS = graphql(/* GraphQL */ `
  query GetAllSystemsForAsset($assetId: Int!) {
    allSystemsForAsset(assetId: $assetId) {
      systemId
      systemNumber
      description
      assetId
    }
  }
`);
